(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cleaning-illustration"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vapurio-comparison-gallery')) {
  customElements.define('vapurio-comparison-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.addEventListener('click', (event) => {
        const button = event.target.closest('.vc-thumb');
        if (!button || !this.contains(button)) return;
        const target = button.getAttribute('aria-controls');
        this.querySelectorAll('.vc-thumb').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        this.querySelectorAll('.vc-panel').forEach((panel) => { panel.hidden = panel.id !== target; });
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
